function getIndexedIdentityIds() {
  return [...this.state.identities.values()];
}
module.exports = getIndexedIdentityIds;
